module.exports = __webpack_public_path__ + "img/Chaumet-Artwork.a2c45852.jpg";